'use strict';

function flickityIos() {
  var touchingCarousel = false;
  var touchStartCoords = '';

  document.body.addEventListener('touchstart', function (event) {
    if (event.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY
    };
  });

  document.body.addEventListener('touchmove', function (event) {
    if (!(touchingCarousel && event.cancelable)) {
      return;
    }

    var moveVector = {
      x: event.touches[0].pageX - touchStartCoords.x,
      y: event.touches[0].pageY - touchStartCoords.y
    };

    if (Math.abs(moveVector.x) > 7) {
      event.preventDefault();
    }
  }, { passive: false });
}

document.addEventListener('DOMContentLoaded', function () {
  flickityIos();
});